export const defaultState = {
  theme: 'system',
  currency: 'USD',
  tools: {
    compound: {
      initialAmount: 5000,
      regularContribution: 200,
      contributionFrequency: 'monthly',
      termYears: 10,
      termMonths: 0,
      annualRate: 6,
      compoundingFrequency: 'monthly',
      contributionTiming: 'end',
      targetAmount: 0,
    },
    loan: {
      amount: 250000,
      termYears: 30,
      termMonths: 0,
      annualRate: 6.5,
      paymentType: 'annuity',
      firstPaymentDate: '',
      showCalendar: false,
    },
    password: {
      length: 32,
      lower: true,
      upper: true,
      digits: true,
      symbols: false,
      excludeSimilar: true,
      excludeAmbiguous: false,
      requireEach: true,
    },
    hash: {
      inputType: 'text',
      text: '',
      algorithm: 'sha256',
      upperCase: false,
      fileName: '',
      fileSize: 0,
      fileType: '',
    },
    base64: {
      mode: 'encode',
      inputType: 'text',
      text: '',
      fileName: '',
      fileSize: 0,
      fileType: '',
    },
    salary: {
      sources: [
        { id: 'source-primary', name: 'Источник 1', amount: 5000 },
      ],
      categories: [
        { id: 'housing', name: 'Housing', amount: 1600 },
        { id: 'savings', name: 'Savings', amount: 750 },
        { id: 'groceries', name: 'Groceries', amount: 550 },
        { id: 'transport', name: 'Transport', amount: 250 },
      ],
    },
  },
};

export const STORAGE_KEY = 'finance-tools-state.v1';
